export const checkSession = (logout: () => void) => {
  let firstNetworkFailureTime: number | null = null;
  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token || token === 'null' || token === 'undefined') {
        logout();
        return;
      }

      const lastRealActivity = localStorage.getItem('lastActivity') || new Date().toISOString();

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/check-session`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Last-Activity': lastRealActivity
          }
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          logout();
          return;
        }
        throw new Error('Session expired');
      }
      firstNetworkFailureTime = null;
    } catch (error) {
      console.error('Session check network error:', error);
      if (!firstNetworkFailureTime) {
        firstNetworkFailureTime = Date.now();
      } else if (Date.now() - firstNetworkFailureTime > 1800000) {
        logout();
      }
    }
  };

  let lastActivityTimeout: NodeJS.Timeout;
  const updateLastActivity = () => {
    localStorage.setItem('lastActivity', new Date().toISOString());
    if (lastActivityTimeout) clearTimeout(lastActivityTimeout);
    lastActivityTimeout = setTimeout(() => logout(), 3600000);
  };
  const events = ['mousemove', 'keydown', 'click', 'scroll'];

  // Add event listeners for user activity
  events.forEach(event => window.addEventListener(event, updateLastActivity));

  // Check every 20 seconds
  const interval = setInterval(checkAuthStatus, 15000);


  // Cleanup
  return () => {
    clearInterval(interval);
    if (lastActivityTimeout) clearTimeout(lastActivityTimeout)
    events.forEach(event => window.removeEventListener(event, updateLastActivity));
  };
};